import * as C from "io-ts/Codec";
import * as Eq from "fp-ts/Eq";
import * as n from "fp-ts/number";

export const GeoCoordModel = C.tuple(C.number, C.number);
export type GeoCoord = C.TypeOf<typeof GeoCoordModel>;
export const eqGeoCoord = Eq.tuple(n.Eq, n.Eq);
